// extracted by mini-css-extract-plugin
export var bubble = "_2u-0";
export var container = "_2u-f";
export var contrastBorder = "_2u-g";
export var greyOut = "_2u-2";
export var initialsColor0 = "_2u-3";
export var initialsColor1 = "_2u-4";
export var initialsColor10 = "_2u-d";
export var initialsColor11 = "_2u-e";
export var initialsColor2 = "_2u-5";
export var initialsColor3 = "_2u-6";
export var initialsColor4 = "_2u-7";
export var initialsColor5 = "_2u-8";
export var initialsColor6 = "_2u-9";
export var initialsColor7 = "_2u-a";
export var initialsColor8 = "_2u-b";
export var initialsColor9 = "_2u-c";
export var initialsWrapper = "_2u-1";
export var large = "_2u-l";
export var medium = "_2u-k";
export var mediumSmall = "_2u-j";
export var mediumSmallMedium = "_2u-o";
export var micro = "_2u-h";
export var small = "_2u-i";
export var tiny = "_2u-n";
export var xTiny = "_2u-m";